export default "// comment       \nconsole.log(\"test\");         \n"